import { useCallback } from 'react'
import { Unit } from '../../types/catalog'
import { ActionsCell, TD, TR } from '../../components/ui/Table'
import { Badge } from '../../components/ui/Badge'
import { Button } from '../../components/ui/Button'

const typeColor = { weight: 'purple', volume: 'green', piece: 'amber' } as const

interface Props {
  item: Unit
  onEdit: (item: Unit) => void
  onDelete: (item: Unit) => void
}
export function UnitRow({ item, onEdit, onDelete }: Props) {
  const handleEdit = useCallback(() => onEdit(item), [item, onEdit])
  const handleDelete = useCallback(() => onDelete(item), [item, onDelete])

  return (
    <TR>
      <TD>
        <code style={{ fontSize: 12, color: '#9b6bb5' }}>{item.code}</code>
      </TD>
      <TD>
        <Badge color={typeColor[item.type]}>{item.type}</Badge>
      </TD>
      <TD>{item.translations.find(t => t.locale === 'en')?.name ?? '—'}</TD>
      <TD>
        <code style={{ fontSize: 12 }}>
          {item.translations.find(t => t.locale === 'en')?.abbreviation ?? '—'}
        </code>
      </TD>
      <TD>{item.translations.find(t => t.locale === 'es')?.name ?? '—'}</TD>
      <TD>
        <code style={{ fontSize: 12 }}>
          {item.translations.find(t => t.locale === 'es')?.abbreviation ?? '—'}
        </code>
      </TD>
      <TD>{item.gramsEquivalent != null ? `${item.gramsEquivalent}g` : '—'}</TD>
      <ActionsCell>
        <Button variant="ghost" size="sm" onClick={handleEdit}>
          Edit
        </Button>
        <Button variant="danger" size="sm" onClick={handleDelete}>
          Delete
        </Button>
      </ActionsCell>
    </TR>
  )
}
